// extracted by mini-css-extract-plugin
module.exports = {"section-separator":"Separator_section-separator__FeR_1","component-separator":"Separator_component-separator__FvP39"};